import React from 'react';
import PropTypes from 'proptypes';
import classnames from 'classnames';
import { NavLink } from 'react-router-dom';

import styles from './footer-nav-component.styles.scss';


export class FooterNavComponent extends React.Component {
  static propTypes = {
    display: PropTypes.oneOf(['row', 'column']),
    className: PropTypes.string,
    onNavigate: PropTypes.func,
  }

  static defaultProps = {
    display: 'row',
    className: '',
    onNavigate: () => {}
  }

  render() {
    const className = classnames(
      styles.FooterNav,
      this.props.className,
      styles[`FooterNav--${this.props.display}`]
    );

    return  (
      <ul className={className}>
        { this.renderNavLink('Impressum', '/imprint') }
        { this.renderNavLink('Nutzungsbedingungen', '/terms') }
        { this.renderNavLink('Urheberecht', '/copyright') }
        { this.renderNavLink('Datenschutzerklärung', '/privacy-policy') }
        { this.renderNavLink('Partner', '/partners') }
      </ul>
    );
  }

  renderNavLink(label, to) {
    const { onNavigate, display } = this.props;
    const className = styles[`Active--${display}`]

    return (
      <li className={styles.MenuItem}>
        <NavLink to={to} activeClassName={className} onClick={onNavigate}>
          { label }
        </NavLink>
      </li>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/footer-nav/footer-nav.component.jsx